export default __webpack_public_path__ + "static/media/alk_hiph-scale.708168e9.png";